const NotificationTypes = {
  forum_message: {
    create: () =>
      import(/* webpackChunkName: "forum_message_create" */ './types/forum_message/create'),
  },
  forum_answer_message: {
    create: () =>
      import(
        /* webpackChunkName: "forum_answer_message_create" */ './types/forum_answer_message/create'
      ),
  },
  training_participation: {
    new: () =>
      import(
        /* webpackChunkName: "training_participation_new" */ './types/training_participation/new'
      ),
  },
  project_submission: {
    create: () =>
      import(
        /* webpackChunkName: "project_submission_create" */ './types/project_submission/create'
      ),
  },
  default: {
    new: () => import(/* webpackChunkName: "default" */ './types/default'),
  },
  enrollment_request: {
    create: () =>
      import(/* webpackChunkName: "forum_message_create" */ './types/enrollment_request/create'),
  },
  failed_notification: {
    create: () =>
      import(
        /* webpackChunkName: "failed_notification_create" */ './types/failed_notification/create'
      ),
  },
  import_user_wrong_email: {
    create: () =>
      import(
        /* webpackChunkName: "import_user_wrong_email_create" */ './types/import_user_wrong_email/create'
      ),
  },
  placement_test_participation: {
    new: () =>
      import(
        /* webpackChunkName: "placement_test_participation_new" */ './types/placement_test_participation/new'
      ),
  },
}

export default NotificationTypes
